import React from 'react';
import { connect } from 'react-redux';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import PropTypes from 'prop-types';
import { FormSection } from 'AppSrc/core/components/forms/form-section';
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import { changePeerRejectionReasonForEditCrqId } from 'AppSrc/core/actions/actions-edit-form';
import { peerRejectionReason } from './peer-rejection-reason';




const getCurrentFields = (params) => {
  // const {
  //   // values = {},
  //   // formData = {},
  //   // touched = {},
  //   // userRoles,
  // } = params;

  const currentFields = [];
  currentFields.push({
    ...defaultFieldLogic,
    componentData: peerRejectionReason,
  });

  return currentFields;
};

const RejectCrqModalDisplay = ({
  closeModal,
  rejectToPrevStatus,
  changePeerRejectionReason,
  network,
  crqId,
}) => {

  const formData = {
    formSectionsByDisplayOrder: [
    ],
    dataByFormSectionId: {
    },
  };


  return (
    <ModalPortal>
      <div
        className="v-f-modal-section cancel-crq-modal"
      >
        <div className="v-f-modal-shadow" />
        <div className="v-f-modal-inner">
          <FormSection
            sectionTitle="Are you sure you want to reject this CRQ?"
            sectionId="reject-crq-modal"
            getCurrentFields={getCurrentFields}
            formData={formData}
            modalOptions={{
              rejectCrq: true,
              back: closeModal,
            }}
            handleSuccessfulSubmit={(data) => {
              const peerRejectionReasonValue = data.dataByFieldId[peerRejectionReason.id].value;
              changePeerRejectionReason({
                crqId,
                peerRejectionReasonValue,
              });
              rejectToPrevStatus(network);
              closeModal();
              window.localStorage.removeItem('isInfoItem');

            }}
          />
        </div>
      </div>
    </ModalPortal>
  );
};

RejectCrqModalDisplay.propTypes = {
  closeModal: PropTypes.func,
  rejectToPrevStatus: PropTypes.func,
  changePeerRejectionReason: PropTypes.func,
  network: PropTypes.string,
  crqId: PropTypes.string,
};




const mapDispatchToProps = (dispatch, ownProps) => ({
  changePeerRejectionReason(params = {}) {
    const {
      crqId,
      peerRejectionReasonValue,
    } = params;
    dispatch(changePeerRejectionReasonForEditCrqId({
      crqId,
      peerRejectionReason: peerRejectionReasonValue,
    }));
  },
});

const RejectCrqModal = connect(
  null,
  mapDispatchToProps,
)(RejectCrqModalDisplay);





export { RejectCrqModal };
